<form [formGroup]="form" (ngSubmit)="save()">
    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#e2d5f6;"><img src="assets/img/icons/section-restricciones-salud.svg" alt=""></span>
            <h5>Restricciones de salud</h5>
        </div>
        <textarea class="field-textarea" formControlName="health_restrictions" [maxlength]="maxHealthRestrictionsLength"
            placeholder="Describe las restricciones o condiciones de salud del trabajador (alergias, enfermedades crónicas, limitaciones físicas, etc.)"></textarea>
        <div class="field-char-count">{{form.get('health_restrictions')?.value?.length || 0}} / {{maxHealthRestrictionsLength}}</div>
    </div>

    <div class="tab-card">
        <div class="tab-card-header">
            <span class="tab-icon-badge" style="background:#ffccce;"><img src="assets/img/icons/section-accidente-avisar.svg" alt=""></span>
            <h5>En caso de accidente avisar a:</h5>
        </div>
        <div class="field-row">
            <div class="field-col">
                <label class="field-label">Nombre completo</label>
                <input type="text" class="field-input" formControlName="emergency_contact_name" placeholder="Ingresar">
            </div>
            <div class="field-col">
                <label class="field-label">Teléfono</label>
                <input type="text" class="field-input" formControlName="emergency_contact_phone" placeholder="Ingresar">
            </div>
        </div>
    </div>

    <div class="tab-save-bar" *ngIf="canDo('Editar')">
        <button type="submit" class="btn btn-primary">Guardar cambios</button>
    </div>
</form>
